import { render, staticRenderFns } from "./ChannelConfiguration.vue?vue&type=template&id=2c4c6030&scoped=true&"
import script from "./ChannelConfiguration.vue?vue&type=script&lang=js&"
export * from "./ChannelConfiguration.vue?vue&type=script&lang=js&"
import style0 from "./ChannelConfiguration.vue?vue&type=style&index=0&id=2c4c6030&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c4c6030",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
installComponents(component, {VCheckbox})
